export enum BreadcrumbCategory {
  Component = 'component',
  GraphNavigation = 'graph navigation',
  Lwa = 'lwa',
}

export enum SentryLevel {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
